<template>
    <div>
        <div v-if="!pinnedInterruptionsLoading" v-for="zapInterruption in zapInterruptions" class="container-inner mx-auto">
            <div class="mt-10">
                <div class="px-6 py-3 text-base text-gray-700 rounded bg-white inset-red-line-left-red-400-md-shadow flex flex-row items-center relative">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" class="text-red-500 mr-4 flex-shrink-0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                    <div class="w-full">
                        <div class="block">
                            <a :href="zapInterruptionUrl + zapInterruption.id"><strong class="underline">{{ zapInterruption.name }}</strong></a>
                            <br>
                            <div v-if="zapInterruption.comment !== null" v-html="zapInterruption.comment"></div>
                            <p v-else>We identified a problem and will work on the solution!</p>
                        </div>
                        <div>
                            <div class="absolute top-0 right-0 mr-4 mt-4 text-current">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 384 512" fill="currentColor">
                                    <path d="M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"/>
                                </svg>
                            </div>
                            <div class="absolute bottom-0 right-0 mr-4 mb-2 flex md:inline-flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                <p>{{ zapInterruption.started_at_human_readable }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="!pinnedInterruptionsLoading" v-for="serviceInterruption in serviceInterruptions" class="container-inner mx-auto">
            <div class="mt-10">
                <div class="px-6 py-3 text-base text-gray-700 rounded bg-white inset-red-line-left-red-400-md-shadow flex flex-row items-center relative">
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24" fill="none" class="text-red-500 mr-4 flex-shrink-0" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
                        <line x1="12" y1="9" x2="12" y2="13"></line>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                    <div class="w-full">
                        <div class="block">
                            <a :href="serviceInterruptionUrl + serviceInterruption.id"><strong class="underline">{{ serviceInterruption.name }}</strong></a>
                            <br>
                            <div v-if="serviceInterruption.comment !== null" v-html="serviceInterruption.comment"></div>
                            <p v-else>We identified a problem and will work on the solution!</p>
                        </div>
                        <div>
                            <div class="absolute top-0 right-0 mr-4 mt-4 text-current">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 384 512" fill="currentColor">
                                    <path d="M32 32C32 14.3 46.3 0 64 0H320c17.7 0 32 14.3 32 32s-14.3 32-32 32H290.5l11.4 148.2c36.7 19.9 65.7 53.2 79.5 94.7l1 3c3.3 9.8 1.6 20.5-4.4 28.8s-15.7 13.3-26 13.3H32c-10.3 0-19.9-4.9-26-13.3s-7.7-19.1-4.4-28.8l1-3c13.8-41.5 42.8-74.8 79.5-94.7L93.5 64H64C46.3 64 32 49.7 32 32zM160 384h64v96c0 17.7-14.3 32-32 32s-32-14.3-32-32V384z"/>
                                </svg>
                            </div>
                            <div class="absolute bottom-0 right-0 mr-4 mb-2 flex md:inline-flex items-center">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="mr-1"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>
                                <p>{{ serviceInterruption.started_at_human_readable }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                pinnedInterruptionsLoading: true,
                zapInterruptions: Array,
                serviceInterruptions: Array,
                zapInterruptionUrl: "/service/interruption/",
                serviceInterruptionUrl: "/interruption/",
            }
        },
        methods: {
            refresh() {
                this.pinnedInterruptionsLoading = true;
                axios.get(route('api.interruption.pinned')).then((response) => {
                    this.zapInterruptions = response.data.interruptions.zapInterruptions;
                    this.serviceInterruptions = response.data.interruptions.serviceInterruptions;

                    this.pinnedInterruptionsLoading = false;
                })
            },
        },
        mounted() {
            this.$eventHub.$on('refresh', this.refresh);

            this.refresh();
        },
    }
</script>
